module.exports = __webpack_public_path__ + "static/media/argumentação01.e0bd2a5d.png";